import { render, staticRenderFns } from "./dubbingClass.vue?vue&type=template&id=6ca8d414&scoped=true"
import script from "./dubbingClass.vue?vue&type=script&lang=js"
export * from "./dubbingClass.vue?vue&type=script&lang=js"
import style0 from "./dubbingClass.vue?vue&type=style&index=0&id=6ca8d414&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca8d414",
  null
  
)

export default component.exports